export default {
  setCodeInvalid: (state, data) => {
    state.codeInvalid = data;
  },
  setCodeValid: (state, data) => {
    state.codeValid = data;
  },
};
